// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"b6e95eab","854":"4c5b393c"}[chunkId] + ".chunk.css";
};